import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";

export default class DeleteIndexGroupTypeInteractor {
  private deleteResource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.deleteResource = deleteResource;
  }

  async execute(model: IIndexTypeGroup) {
    return this.deleteResource.execute(Constants.indexGroupBasePath, model.id);
  }
}
